import ModalService from "services/modal";

export const changePageConfirm = new ModalService("changePageConfirm");
